<template>
  <ms-header>
    <ms-header-nav :header-data="headerData"></ms-header-nav>
  </ms-header>
</template>

<script>
export default {
  name: 'EmailCaptureHeader',
  props: ['customLogo'],
  data() {
    return {
      headerData: {
        logo: {
          alt: 'MoneySmart Logo',
          src: this.customLogo || 'https://assets.cdn-moneysmart.com/assets/cargo/svg/w5vwxizv54d1kcnlfsds.svg',
          link: process.env.REGION_WEBSITE
        },
        country_code: process.env.REGION_CODE,
        navigation_items: []
      }
    }
  }
}
</script>